import * as types from "../actionTypes";

export function setCurrentUser(payload) {
	// console.log(payload);
	return { type: types.SET_CURRENT_USER, payload };
}
export function setCurrentView(payload) {
	// console.log(payload);
	return { type: types.SET_CURRENT_USER_VIEW, payload };
}
export function monitorUserSuccess(payload) {
	return { type: types.MONITOR_USER_SUCCESS, payload };
}

export function addUser(payload) {
	return { type: types.ADD_NEW_USER, payload };
}

export function updateUser(payload) {
	return { type: types.UPDATE_USER, payload };
}

export function getUsersSuccess(payload) {
	return { type: types.GET_USERS_SUCCESS, payload };
}

export function logUserOut() {
	return { type: types.LOGOUT_USER, payload: "" };
}

export function loginUserSuccess(payload) {
	return { type: types.LOGIN_USER, payload };
}

export function setLoggedIn(payload) {
	return { type: types.SET_LOGGED_IN, payload };
}

export function getUserNotificationsSuccess(payload) {
	return { type: types.GET_USER_NOTIFICATIONS_SUCCESS, payload };
}
